// extracted by mini-css-extract-plugin
module.exports = {"root":"C_b9","item":"C_bg","item-img":"C_cs","itemImg":"C_cs","grid-item-title":"C_ct","gridItemTitle":"C_ct"};